import { useMemo } from "react";
import { Column } from "../../components/ui/table";
import { StructureObject } from "../utils/enums/structure-object";
import { findStructureFieldByKey } from "./useStructureStore";

export function useStructureColumnsStore(
  baseColumns: Column[],
  fields: StructureObject["fields"]
) {
  return useMemo(() => {
    return baseColumns
      .map((col) => {
        const field = findStructureFieldByKey(fields, col.key);

        return field
          ? {
            ...col,
            label: field.label,
            visible: field.visible,
          }
          : col;
      })
      .filter((col) => col.visible !== false);
  }, [baseColumns, fields]);
}

export function syncTableColumnsWithStructure(
  entity: string,
  fields: StructureObject["fields"]
) {
  const storageKey = `${entity}-table-columns`;
  const saved = localStorage.getItem(storageKey);

  if (!saved) return;

  try {
    const parsed: Column[] = JSON.parse(saved);

    const allFieldKeys = Object.values(fields)
      .flat()
      .map((f) => f.key);

    const updated = parsed
      .filter((col) => allFieldKeys.includes(col.key))
      .map((col) => {
        const field = Object.values(fields)
          .flat()
          .find((f) => f.key === col.key);

        return field
          ? { ...col, label: field.label, visible: field.visible }
          : col;
      });

    localStorage.setItem(storageKey, JSON.stringify([{ key: "isChecked", label: "", visible: true }, ...updated]));
  } catch (e) {
    localStorage.removeItem(storageKey);
  }
}
